import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import { PersistQueryClientProvider } from '@tanstack/react-query-persist-client'
import { PropsWithChildren, useState } from 'react'

import { createQueryClient, createQueryPersister } from '@/integrations/react-query'

export const QueryProvider = ({ children }: PropsWithChildren) => {
  const [queryClient] = useState(() => createQueryClient())
  // Shared singleton rather than a local instance: signing out purges the persisted cache through
  // the same persister (see `resetQueryCache`).
  const [asyncPersister] = useState(() => createQueryPersister())

  return (
    <PersistQueryClientProvider client={queryClient} persistOptions={{ persister: asyncPersister }}>
      {children}
      <ReactQueryDevtools initialIsOpen={false} />
    </PersistQueryClientProvider>
  )
}
